import React from 'react';
import styles from "./home.module.scss";
import {MuiTextField} from "../../../components/MuiComponents/FormInputs";
import Typography from "../../../components/Typography";
import Button from "../../../components/Button";
import LineThrough from "../../../components/LineThrough";
import {useForm} from "react-hook-form";
import {email} from "../../../utils/validations";
import {useDispatch, useSelector} from "react-redux";
import {clearFormError, setAuthInputs, setForgotPasswordModal, setFormError} from "../../../redux/reducers/auth";
import {useMutation} from "react-query";
import {loginWithGoogle, register2fa, signIn} from "../../../api/mutations/auth";
import MainLoader from "../../../components/Loader/MainLoader";
import GoogleLogin from "react-google-login";
import {grantAccess} from "../../../actions/authActions";
import {GOOGLE_CLIENT_ID} from "../../../utils/constants";

const SignInCard = () => {
    const {register, handleSubmit, formState: {errors}} = useForm()
    const dispatch = useDispatch()
    const mutation = useMutation(signIn)
    const googleLogin = useMutation(loginWithGoogle)
    const _2FaMutation = useMutation(register2fa)
    const formErrors = useSelector(state => state.auth.formErrors)
    const submit = async (data) => {
        try {
            let res = await mutation.mutateAsync(data)
            let _2FaData = null
            if (!res?.user?.tfa_enabled)
                _2FaData = await _2FaMutation.mutateAsync(res.token)
            dispatch(setAuthInputs({
                openAuthenticatorModal: true,
                user: res.user,
                token: res.token,
                _2FaData: _2FaData?.data
            }))
            dispatch(clearFormError("login_form"))
        } catch (e) {
            dispatch(setFormError({
                login_form: e?.response?.data?.message || "error"
            }))
        }
    }

    const responseGoogle = async (response) => {
        if (response?.tokenId) {
            try {
                let res = await googleLogin.mutateAsync(response?.tokenId)
                grantAccess(res.token, res.user)
            } catch (e) {
                dispatch(setFormError({
                    google_login: "Google Login failed. Please try again with your username and password"
                }))
            }
        }
    }

    let disabled = Object.keys(errors).length > 0
    return (
        <div className={`card shadow-sm md:shadow-none ${styles.card} mt-5 sm:mt-24 hlg:mt-10`}>
            {(mutation.isLoading || _2FaMutation.isLoading || googleLogin.isLoading) && <MainLoader/>}
            <h5 className={"mb-1"}>Sign In</h5>
            <form onSubmit={handleSubmit(submit)} noValidate>
                <MuiTextField label={"Your Email Id"}
                              InputProps={{...register("email", {required: "Enter Your Email Id", ...email})}}
                              error={Boolean(errors?.email)}
                              helperText={errors?.email?.message}
                              type={"email"}
                />
                <MuiTextField label={"Your Password "} type={"password"}
                              InputProps={{...register("password", {required: "Enter Your Password"})}}
                              error={Boolean(errors?.password)}
                              helperText={errors?.password?.message}
                />
                <Typography className={"text-functional-red"}>{formErrors?.login_form}</Typography>
                <Typography onClick={() => dispatch(setForgotPasswordModal(true))} variant={"subtitle2"}
                            className={"text-secondary-700 mt-1 cursor-pointer inline-block"}>Forgot
                    password?</Typography>
                <Button disabled={disabled} fullWidth className={"mt-5"}>Sign In</Button>
            </form>
            {/*<LineThrough className={`mt-7 text-black ${styles.divider}`}>OR</LineThrough>*/}
            {/*<GoogleLogin*/}
            {/*    clientId={GOOGLE_CLIENT_ID}*/}
            {/*    render={renderProps => (*/}
            {/*        <Button onClick={renderProps.onClick} disabled={renderProps.disabled}*/}
            {/*                fullWidth={true}*/}
            {/*                className={styles.google_sign_in}*/}
            {/*        >*/}
            {/*            <img className={styles.icon} src="/images/google.png" alt=""/>*/}
            {/*            Sign In With Google</Button>*/}
            {/*    )}*/}
            {/*    onSuccess={responseGoogle}*/}
            {/*    onFailure={(e) => {*/}
            {/*        console.log(e, "google login")*/}
            {/*    }}*/}
            {/*    cookiePolicy={'single_host_origin'}*/}
            {/*/>*/}
            {/*<Typography className={"text-functional-red mt-1"}>{formErrors?.google_login}</Typography>*/}
        </div>
    );
};

export default SignInCard;
